import { post, get, patch, deleteRequest } from "./restApi";

export const getConditionalMaintenances = (payload) => {
  return patch("conditionalMaintenance/get-list", { ...payload });
};
export const getConditionalBaseByConditionalMaintenanceId = (payload) => {
  return get(
    `conditionalMaintenance/get-conditional-base-by-conditional-maintenance`,
    { ...payload },
  );
};
export const generateSchedulePrenventiveByConditionalMaintenance = (
  payload,
) => {
  return patch(
    `conditionalMaintenance/generate-schedule-preventive-by-conditional-maintenance`,
    { ...payload },
  );
};
export const getConditionalMaintenanceMeasurementByConditionalMaintenance = (
  payload,
) => {
  return get(
    `conditionalMaintenance/get-conditional-maintenance-measurement-by-conditional-maintenance`,
    { ...payload },
  );
};
export const confirmCancelConditionalMaintenance = (payload) => {
  return patch(`conditionalMaintenance/confirm-cancel-conditional-maintenance`, {
    ...payload,
  });
}
